import { render } from "./Bagging.vue?vue&type=template&id=6e3473c6&scoped=true"
import script from "./Bagging.vue?vue&type=script&lang=js"
export * from "./Bagging.vue?vue&type=script&lang=js"

import "./Bagging.vue?vue&type=style&index=0&id=6e3473c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3473c6"]])

export default __exports__